import classNames from 'classnames';
import { type ComponentProps, type ReactNode } from 'react';

import { Avatar } from '@air/primitive-avatar';

import { getAvatarImageSrc } from '~/utils/getAvatarImageSrc';

const AVATAR_SIZE = 32;

export type LibraryInviteMemberListItemProps = Pick<ComponentProps<'div'>, 'className'> & {
  colorSeed?: string;
  avatar?: string;
  label: string;
  meta?: string;
  suffix?: ReactNode;
};

export const LibraryInviteMemberListItem = ({
  avatar,
  className,
  colorSeed,
  label,
  meta,
  suffix,
}: LibraryInviteMemberListItemProps) => {
  const initials = label
    .split(' ')
    .map((word) => word[0])
    .join('');

  return (
    <div
      className={classNames(
        'flex h-12 grow cursor-pointer items-center gap-3 rounded-4 px-2 ads:hover:bg-hover-subtle hover:bg-pigeon-50',
        className,
      )}
    >
      <Avatar
        alt={`${label} avatar`}
        appearance="circle"
        className="shrink-0"
        colorSeed={colorSeed}
        size={AVATAR_SIZE}
        src={getAvatarImageSrc(avatar, AVATAR_SIZE)}
        text={initials}
      />

      <div className="flex grow flex-col">
        <div className="font-medium ads:text-secondary text-14 text-pigeon-600">{label}</div>

        {!!meta && <div className="ads:text-metadata text-12 text-pigeon-400">{meta}</div>}
      </div>

      {!!suffix && <div className="shrink-0 ads:text-metadata text-12 text-pigeon-400 capitalize">{suffix}</div>}
    </div>
  );
};
